// extracted by mini-css-extract-plugin
module.exports = {"table":"ConfigTable_table__3YXIF","headerList":"ConfigTable_headerList__2i1e7","iconBtnHead":"ConfigTable_iconBtnHead__2BgX_"};